import { BaseSerializer } from './base.serializer'
import { CenterRegistrationSection } from 'models/center-registration-section.model'
import { Lesson } from 'models/lesson.model'
import { StartExamConfig } from 'models/start-exam-config.model'
import { StaticScreen } from 'models/static-screen.model'
import { SystemScreen } from 'models/system-screen.model'
import { Video } from 'models/video.model'

export class CenterRegistrationSectionSerializer extends BaseSerializer<CenterRegistrationSection> {
  static SERIALIZABLE_ATTRIBUTES = ['_destroy', 'contentId', 'id', 'position', 'type']
  static SERIALIZERS = {}
  static SERIALIZE_RENAME_KEYS = {}

  static DESERIALIZERS = {}
  static DESERIALIZE_RENAME_KEYS = {}

  static initializeObject(attributes: Object): CenterRegistrationSection {
    if(attributes['content']) {
      if(attributes['type'] == 'static_screen') {
        attributes['content'] = new StaticScreen(attributes['content'])
      }
      else if(attributes['type'] == 'system_screen') {
        attributes['content'] = new SystemScreen(attributes['content'])
      }
      else if(attributes['type'] == 'video') {
        attributes['content'] = new Video(attributes['content'])
      }
    }
    return new CenterRegistrationSection(attributes)
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/serializers/center-registration-section.serializer.ts